export const faqs = [
  {
    q: 'How will I receive REFLEXOLOGY 21-DAY PRACTICE METHOD™?',
    a: "Immediately after completing your purchase, you'll receive instructions to access the 6 volumes and 5 bonuses in digital format.",
  },
  {
    q: 'How much time do I need each day?',
    a: 'The method is designed around approximately 15 minutes per day. You can adapt the pace to your own schedule and experience.',
  },
  {
    q: 'Do I need previous reflexology experience?',
    a: 'The method is designed primarily for people who are learning reflexology or want more structure in their existing study and practice routine.',
  },
  {
    q: 'Is this a reflexology certification?',
    a: 'No. REFLEXOLOGY 21-DAY PRACTICE METHOD™ is an educational study and practice organization system. It is not a professional certification.',
  },
  {
    q: 'Is this a video course?',
    a: "No. It's a digital visual practice system containing 6 volumes, planners, study cards, checklists, practice sheets, and quick-reference resources.",
  },
  {
    q: 'Can I use it on my phone?',
    a: 'Yes. The digital materials are designed for convenient reference on your phone, tablet, or computer.',
  },
  {
    q: 'Can I print the materials?',
    a: 'Yes. The planners, cards, worksheets, and checklists can be prepared for printing.',
  },
  {
    q: 'Is it a one-time payment?',
    a: 'Yes. You pay $27 once and receive access to everything included in the offer.',
  },
  {
    q: 'Do I get lifetime access?',
    a: 'Yes, according to the access terms provided at purchase.',
  },
  {
    q: "What if I don't like it?",
    a: "You have a 7-day guarantee, subject to the purchase terms. You can explore the materials and request a refund if you decide the system isn't right for you.",
  },
];
